import { render } from "./expences.vue?vue&type=template&id=23b325b8&scoped=true"
import script from "./expences.vue?vue&type=script&lang=js"
export * from "./expences.vue?vue&type=script&lang=js"

import "./expences.vue?vue&type=style&index=0&id=23b325b8&lang=scss&scoped=true"

import exportComponent from "D:\\Abdulahad\\Front end\\at_rp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23b325b8"]])

export default __exports__